import React, { useState } from "react";
import { MeshStandardMaterial, BoxGeometry, EdgesGeometry } from "three";

const Slabs = ({ slabs, selectedFloor, structuralCalculus }) => {
  const hideMaterial = new MeshStandardMaterial({
    color: "#e2eeee",
    transparent: true,
    opacity: 0.1,
  });
  const hoverMaterial = new MeshStandardMaterial({
    color: "#f7e702", // Amarillo en hover
    transparent: true,
    opacity: 0.7,
  });

  const { slabsStructural } = structuralCalculus;
  const [hoveredSlab, setHoveredSlab] = useState(null);

  return (
    <>
      {slabs.map((slab) => {
        const { id, position, geometry } = slab;
        const { floor, center } = position;
        const { lengthX, lengthZ, thickness } = geometry;
        const { x, y, z } = center;

        // Verificar si structuralCalculus tiene datos y buscar el ID
        const calc = Array.isArray(slabsStructural)
          ? slabsStructural.find(
              (item) => item.id === id && item.floor === floor
            )
          : null;
        const passes = calc ? calc.pass : null;

        let color = "#d10de8"; // Color por defecto
        if (passes === true) color = "#69e522"; // Verde si pasa
        if (passes === false) color = "#d91d1d"; // Rojo si no pasa

        // Material según el estado de hover
        const selectedMaterial = new MeshStandardMaterial({
          color,
          transparent: true,
          opacity: 0.7,
        });

        const material =
          hoveredSlab === id
            ? hoverMaterial
            : floor === selectedFloor
            ? selectedMaterial
            : hideMaterial;

        // Geometría y bordes
        const boxGeometry = new BoxGeometry(lengthX, thickness, lengthZ);
        const edgesGeometry = new EdgesGeometry(boxGeometry);

        return (
          <group key={id} position={[x, y - thickness / 2, z]}>
            <mesh
              name={`Slab_${id}_Floor${floor}`} // ← Renombrado, no comienza con "mesh"
              geometry={boxGeometry}
              material={material}
              onClick={() =>
                floor === selectedFloor
                  ? alert(
                      `Momento en X: ${Number(calc?.MuCalculated?.MuX || 0).toFixed(
                        2
                      )} T-m\nMomento en Z: ${Number(
                        calc?.MuCalculated?.MuZ || 0
                      ).toFixed(2)} T-m`
                    )
                  : null
              }
              onPointerOver={() => floor === selectedFloor ? setHoveredSlab(id) : null}
              onPointerOut={() => floor === selectedFloor ? setHoveredSlab(null) : null}
            />
            {floor === selectedFloor && (
              <lineSegments 
                geometry={edgesGeometry}
                name={`SlabEdges_${id}_Floor${floor}`} // ← También renombrado
              >
                <lineBasicMaterial color={"black"} linewidth={1} />
              </lineSegments>
            )}
          </group>
        );
      })}
    </>
  );
};

export default Slabs;